import React, { useState, useEffect, use } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { FaHeart, FaRegHeart } from "react-icons/fa";
import { MdCalendarViewMonth, MdIosShare, MdOutlineBallot, MdOutlineLabel, MdOutlineRemoveRedEye, MdOutlineSwapVert, MdOutlineVerticalSplit, MdSubject } from "react-icons/md";
import { fetchEthPriceToUSDT } from "../../../hooks/Tokenhook";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import { SlGraph } from "react-icons/sl";
import item_2 from "../../../assets/img/items/item_1.png"
import CollcetionItemCard from "../../../components/collection/CollectionItemCard";
import ether from "../../../assets/img/icons/ether.png";
import ipfsImg from "../../../assets/img/icons/ipfs.jpg";
import { getCollectionDetails } from "../../../hooks/Collectionhook";
import { ethers, getBigInt, toBigInt } from "ethers";
import { ToastContainer, toast } from "react-toastify";
import { useSelector } from "react-redux";
import { ContractABI } from "../../../config/ABIs/ContractABI";
import CopyToClipboard from "react-copy-to-clipboard";
import { auction_contract_address, contractAddress } from "../../../config/BackendUrl";
import { Tooltip } from "react-tooltip";
import { AddActivityNFT, getNFT, likeNFT, updateNFT } from "../../../hooks/NFTHook";
import { Button, Modal } from "react-bootstrap";
import { getUserByAddress } from "../../../hooks/User";
import { collectionABI } from "../../../config/ABIs/CollectionABI";
import { Puff } from "react-loader-spinner";
import "./NFTdetails.css";
import { FaArrowUpLong } from "react-icons/fa6";
import { CreateAuction } from "../../../hooks/AuctionHook";

export const NFTDetails = () => {
  const { nftId, collectionAddress } = useParams();
  const [nft, setNft] = useState(null);
  const [properties, setProperties] = useState([]);
  const [openPanel, setOpenPanel] = useState(null);
  const [openPanel1, setOpenPanel1] = useState("details");
  const [priceInDoller, setpriceInDoller] = useState(0);
  const [collectionDetails, setCollectionDetails] = useState(null);
  const codeSnippet = window.location.href;
  const [receiverAddress, setReceiverAddress] = useState('');
  const [openModalState, setOpenModalState] = useState(false);
  const [nftAction, setNftAction] = useState(null);
  const [priceforMarket, setPriceForMarket] = useState('');
  const [autoClose, setAutoClose] = useState(false);
  const [isTransacting, setIsTransacting] = useState(false);
 const [timeSelectModal, setTimeSelectModal] = useState(false);
  const route = useNavigate();

  const [endTime, setEndTime] = useState();
  const walletAddress = localStorage.getItem("WalletAddress");
  const PROVIDER = useSelector((state) => state.valueFromHeader);
  const [isCopied, setIsCopied] = useState(false);
  const [isLike, setIsLike] = useState(null);
  const userId = localStorage.getItem("userId");
  const navigate = useNavigate();

    // Modal States
    const [modals, setModals] = useState({
      approvalModal: false,
      timeSelectModal: false,
    });

  const RerouteManage = localStorage.getItem('stateManage');

  useEffect(() => {
    loadNFT();
    // GetCollectionDetails()
    localStorage.setItem('stateManage', false)
  }, [RerouteManage]);


  const onCopyText = () => {
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 1000);
  };

  useEffect(() => {
    loadNFT();
  }, [autoClose])

  // const openModal = (type) => {
  //   setModals((prev) => ({ ...prev, [type]: true }));
  // };

  const closeModals = () => {
    setModals({ approvalModal: false, timeSelectModal: false });
  };

  const loadNFT = async () => {
    if (collectionAddress === contractAddress) {
      await getNFT(nftId).then(async (data) => {
        console.log("Data", data);
        if (data.success) {
          const NFTs = data.data;
          // setNft(NFTs);
          const isLike = NFTs?.likes.some(like => like.userId === userId);
          setIsLike(isLike)
          const Proieff = await fetchEthPriceToUSDT(Number(NFTs.price))
          setpriceInDoller(Proieff);
          const updatedActivity = await Promise.all(
            NFTs.activity.map(async (activity) => {
              try {
                const fromUserData = await getUserByAddress(activity.from);
                const toUserData = await getUserByAddress(activity.to);

                return {
                  ...activity,
                  fromUser: fromUserData?.user || null,
                  toUser: toUserData?.user || null,
                };
              } catch (error) {
                console.error("Error fetching user data:", error);
                return activity;
              }
            })
          );

          // Update the NFT data with enriched activity details
          setNft({
            ...NFTs,
            activity: updatedActivity,
          });
        }
      })
    }
    else {
      await getNFT(nftId).then(async (data) => {
        console.log("Data", data);
        if (data.success) {
          const NFTs = data.data;
          // setNft(NFTs);
          const isLike = NFTs?.likes.some(like => like.userId === userId);
          setIsLike(isLike)
          const updatedActivity = await Promise.all(
            NFTs.activity.map(async (activity) => {
              try {
                const fromUserData = await getUserByAddress(activity.from);
                const toUserData = await getUserByAddress(activity.to);

                return {
                  ...activity,
                  fromUser: fromUserData?.user || null,
                  toUser: toUserData?.user || null,
                };
              } catch (error) {
                console.error("Error fetching user data:", error);
                return activity;
              }
            })
          );

          // Update the NFT data with enriched activity details
          setNft({
            ...NFTs,
            activity: updatedActivity,
          });
          const Proieff = await fetchEthPriceToUSDT(Number(NFTs.price))
          setpriceInDoller(Proieff);
          GetCollectionDetails()
        }
      })
      // await getNFT(nftId).then((data) => {
      //   console.log("Data we", data);
      //   GetCollectionDetails()

      // })

    }
  }


  const GetCollectionDetails = async () => {
    await getCollectionDetails(collectionAddress).then((data) => {
      console.log("collections", data);

      if (data.status === 201) {
        setCollectionDetails(data.data)
      }
    })
  }

  const togglePanel = (panelId) => {
    setOpenPanel(openPanel === panelId ? '' : panelId);
  };

  const handleError = (event) => {
    event.target.src = item_2;
  };

  async function buyNft() {
    try {
      if (!walletAddress) {
        toast.error("Please connect Wallet first");
        return;
      }

      const wallet = await PROVIDER.getSigner();
      console.log("Step 1 => Wallet", wallet, nft, walletAddress);

      const contract = new ethers.Contract(
        nft.contractAddress,
        ContractABI,
        wallet
      );
      console.log("Step 2 => contract", contract, nft.tokenId, {
        value: ethers.parseUnits(nft.price + "", "ether")
      });

      const transaction = await contract.buyToken(nft.tokenId, {
        value: ethers.parseUnits(nft.price.toString(), "ether"),
        gasLimit: 300000
      });

      toast.loading("Transaction in progress...");
      const receipt = await transaction.wait();
      console.log("receipt", receipt);
      console.log("Step 4 => receipt", receipt);

      if (receipt) {
        const transferEventSignatures = ethers.keccak256(ethers.toUtf8Bytes("Transfer(address,address,uint256)"));
        const logs = receipt.logs.filter((log) => log.topics[0] === transferEventSignatures);
        console.log("Step 5 => logs", logs);

        let tokenId, from, to, transactionHash;
        if (logs.length > 0) {
          logs.forEach(async (log) => {
            const rawFrom = log.topics[1];
            const rawTo = log.topics[2];
            from = rawFrom !== `0x${"0".repeat(64)}` ? ethers.getAddress(rawFrom.slice(-40)) : "Minting (no from)";
            to = rawTo !== `0x${"0".repeat(64)}` ? ethers.getAddress(rawTo.slice(-40)) : "Burning (no to)";

            transactionHash = log.transactionHash;
            tokenId = getBigInt(log.topics[3]).toString();
            console.log("Step 6 => Minted Token ID:", tokenId, from, to, transactionHash);

            const NFTbody = {
              listed: false,
              currentOwner: {
                userId: userId,
                walletAddress: walletAddress
              }
            }

            console.log("Step 7 => NFTbody", NFTbody);

            await updateNFT(nft._id, NFTbody)
            const activityBody = {
              event: "Traded",
              price: nft.price,
              from: from,
              to: to
            }
            await AddActivityNFT(nft._id, activityBody).then((data) => {
              toast.success(`NFT ${nft.tokenId} Buy Successfully !!!`);
              loadNFT()
            })
          });
        } else {
          toast.error("Unable to find Transfer event in raw logs.");
        }
      }
    }
    catch (error) {
      console.error("Buy NFT Error:", error);
      toast.error(error?.reason || "Buy NFT failed, please try again later.");
    }
  }

  async function buyLazyNft() {
    if (!walletAddress) {
      toast.error("Please connect Wallet first !!!")
    }
    else {
      try {
        const wallet = await PROVIDER.getSigner();
        const contract = new ethers.Contract(
          collectionAddress,
          collectionABI,
          wallet
        );

        console.log("NFTProcue", nft, nft);

        //  user will be prompted to pay the asking proces to complete the transaction
        const priceInWei = ethers.parseUnits(nft.price + "", "ether");
        console.log("NFTProcue", priceInWei);

        const Signature = [priceInWei, nft.tokenUri, nft.signature[0], toBigInt(nft.royaltyFraction)];
        console.log("Signature", Signature);

        const transaction = await contract.lazyMint(
          Signature,
          {
            value: priceInWei,
          })
        console.log("transaction", transaction);

        toast.loading("Transaction in progress...");
        const receipt = await transaction.wait();
        console.log("receipt", receipt);

        if (receipt) {
          const transferEventSignatures = ethers.keccak256(ethers.toUtf8Bytes("Transfer(address,address,uint256)"));
          const logs = receipt.logs.filter((log) => log.topics[0] === transferEventSignatures);
          console.log("Step 5 => logs", logs);

          let tokenId, from, to, transactionHash;
          if (logs.length > 0) {
            logs.forEach(async (log) => {
              const rawFrom = log.topics[1];
              const rawTo = log.topics[2];
              from = rawFrom !== `0x${"0".repeat(64)}` ? ethers.getAddress(rawFrom.slice(-40)) : "Minting (no from)";
              to = rawTo !== `0x${"0".repeat(64)}` ? ethers.getAddress(rawTo.slice(-40)) : "Burning (no to)";

              transactionHash = log.transactionHash;
              tokenId = getBigInt(log.topics[3]).toString();
              console.log("Step 6 => Minted Token ID:", tokenId, from, to, transactionHash);

              const NFTbody = {
                listed: false,
                tokenId: tokenId,
                transactionHash: transactionHash,
                currentOwner: {
                  userId: userId,
                  walletAddress: walletAddress
                },
                type: "Direct Mint"
              }

              console.log("Step 7 => NFTbody", NFTbody);

              await updateNFT(nft._id, NFTbody)
              const activityBody = {
                event: "Minted",
                price: nft.price,
                from: from,
                to: to
              }
              await AddActivityNFT(nft._id, activityBody).then((data) => {
                toast.success(`NFT ${nft.tokenId} Buy Successfully !!!`);
                loadNFT()
              })
            });
          } else {
            toast.error("Unable to find Transfer event in transaction logs.");
          }
        }
      }
      catch (error) {
        toast.error(error.reason || "Lazy Mint failed. Please try again.");
      }
    }
  };

  const RemoveFromMarket = async () => {
    const toastId = pendingToast("Processing for Remove NFT...");
    // setIsTransacting(true);
    setAutoClose(false)
    try {
      const wallet = await PROVIDER.getSigner();
      toast.update(toastId, {
        render: (
          <div className="d-flex align-items-center">
            <Puff size={20} color="#CC0000" />
            <span className="ml-2">Processing transaction...</span>
          </div>
        )
      });
      console.log("Test step 1", nft.contractAddress, ContractABI, wallet, nft);

      const contract = new ethers.Contract(nft.contractAddress, ContractABI, wallet);
      const transaction = await contract.removeNftFromMarket(nft.tokenId);
      console.log("transaction", transaction, contract);

      toast.update(toastId, {
        render: (
          <div className="d-flex align-items-center">
            <Puff size={20} color="#CC0000" />
            <span className="ml-2">Waiting for confirmation...</span>
          </div>
        )
      });
      const receipt = await transaction.wait();
      console.log("res", receipt);

      if (receipt) {
        const transferEventSignatures = ethers.keccak256(ethers.toUtf8Bytes("Transfer(address,address,uint256)"));
        // Filter logs for Transfer events
        const logs = receipt.logs.filter((log) => log.topics[0] === transferEventSignatures);
        console.log("Step 5 => logs", logs, receipt, receipt.logs);

        const NFTbody = {
          listed: false,
        }

        console.log("Step 7 => NFTbody", NFTbody);

        await updateNFT(nft._id, NFTbody)
        const activityBody = {
          event: "Listed",
          price: 0,
          from: walletAddress,
          to: walletAddress
        }
        await AddActivityNFT(nft._id, activityBody).then((data) => {
          toast.dismiss(toastId);
          toast(<CustomSuccessToast
            transactionHash={nft.transactionHash}
            contractAddress={nft.contractAddress}
            tokenId={data.data._id}
            message={`Remove NFT ${nft.tokenId} from Market !!!`}
          />);
          setAutoClose(true)
          loadNFT()
        })

        // let tokenId, from, to, transactionHash;
        // if (logs.length > 0) {
        //   logs.forEach(async (log) => {
        //     // Extract tokenId directly from topics[3]
        //     const rawFrom = log.topics[1];
        //     const rawTo = log.topics[2];
        //     // Decode the 'from' and 'to' addresses, handling zero address scenarios
        //     from = rawFrom !== `0x${"0".repeat(64)}` ? ethers.getAddress(rawFrom.slice(-40)) : "Minting (no from)";
        //     to = rawTo !== `0x${"0".repeat(64)}` ? ethers.getAddress(rawTo.slice(-40)) : "Burning (no to)";

        //     transactionHash = log.transactionHash;
        //     tokenId = getBigInt(log.topics[3]).toString();
        //     console.log("Step 6 => Minted Token ID:", tokenId, from, to, transactionHash);

        //     const NFTbody = {
        //       listed: false,
        //     }

        //     console.log("Step 7 => NFTbody", NFTbody);

        //     await updateNFT(nft._id, NFTbody)
        //     const activityBody = {
        //       event: "Listed",
        //       price: priceforMarket,
        //       from: walletAddress,
        //       to: walletAddress
        //     }
        //     await AddActivityNFT(nft._id, activityBody).then((data) => {
        //       toast.dismiss(toastId);
        //       toast(<CustomSuccessToast
        //         transactionHash={transactionHash}
        //         contractAddress={contractAddress}
        //         tokenId={data.data._id}
        //         message={`Remove NFT ${nft.tokenId} from Market !!!`}
        //       />);
        //       setAutoClose(true)
        //       loadNFT()
        //     })
        //   });
        // } else {
        //   toast.dismiss(toastId);
        //   setAutoClose(true);
        //   toast.error("Unable to find Transfer event in transaction logs.", 'error');
        // }
      }
    } catch (error) {
      toast.dismiss(toastId);
      setAutoClose(true);
      toast.error(error.reason || "Remove from Market failed. Please try again.", 'error');
    }
  };

  const redeployOnMarketplace = async () => {
    console.log("Marketplace");
    const toastId = pendingToast("Processing for Remove NFT...");
    // setIsTransacting(true);
    setAutoClose(false)
    if (!priceforMarket || isNaN(priceforMarket)) {
      toast.dismiss(toastId);
      toast.error("Invalid price. Please enter a valid amount.");
      setAutoClose(true)
      return;
    }

    try {
      const wallet = await PROVIDER.getSigner();
      toast.update(toastId, {
        render: (
          <div className="d-flex align-items-center">
            <Puff size={20} color="#CC0000" />
            <span className="ml-2">Processing transaction...</span>
          </div>
        )
      });
      const contract = new ethers.Contract(nft.contractAddress, ContractABI, wallet);
      console.log("transaction", contract, nft.contractAddress, ContractABI, wallet);

      const priceInEther = ethers.parseEther(priceforMarket);
      console.log("transaction", priceInEther, contract);

      const transaction = await contract.addNftToMarket(nft.tokenId, priceInEther);
      console.log("transaction", transaction, priceInEther, contract);

      toast.update(toastId, {
        render: (
          <div className="d-flex align-items-center">
            <Puff size={20} color="#CC0000" />
            <span className="ml-2">Waiting for confirmation...</span>
          </div>
        )
      });
      const receipt = await transaction.wait();
      if (receipt) {
        const transferEventSignatures = ethers.keccak256(ethers.toUtf8Bytes("Transfer(address,address,uint256)"));
        // Filter logs for Transfer events
        const logs = receipt.logs.filter((log) => log.topics[0] === transferEventSignatures);
        console.log("Step 5 => logs", logs, receipt, receipt.logs);

        const NFTbody = {
          listed: true,
          price: priceforMarket,
        }

        console.log("Step 7 => NFTbody", NFTbody);

        await updateNFT(nft._id, NFTbody)
        const activityBody = {
          event: "Tr",
          price: priceforMarket,
          from: walletAddress,
          to: walletAddress
        }
        await AddActivityNFT(nft._id, activityBody).then((data) => {
          toast.dismiss(toastId);
          toast(<CustomSuccessToast
            transactionHash={nft.transactionHash}
            contractAddress={nft.contractAddress}
            tokenId={data.data._id}
            message={`NFT added to the marketplace successfully!`}
          />);
          setAutoClose(true)
          loadNFT()
        })
        // let tokenId, from, to, transactionHash;
        // if (logs.length > 0) {
        //   logs.forEach(async (log) => {
        //     // Extract tokenId directly from topics[3]
        //     const rawFrom = log.topics[1];
        //     const rawTo = log.topics[2];
        //     // Decode the 'from' and 'to' addresses, handling zero address scenarios
        //     from = rawFrom !== `0x${"0".repeat(64)}` ? ethers.getAddress(rawFrom.slice(-40)) : "Minting (no from)";
        //     to = rawTo !== `0x${"0".repeat(64)}` ? ethers.getAddress(rawTo.slice(-40)) : "Burning (no to)";

        //     transactionHash = log.transactionHash;
        //     tokenId = getBigInt(log.topics[3]).toString();
        //     console.log("Step 6 => Minted Token ID:", tokenId, from, to, transactionHash);

        //     const NFTbody = {
        //       listed: true,
        //     }

        //     console.log("Step 7 => NFTbody", NFTbody);

        //     await updateNFT(nft._id, NFTbody)
        //     const activityBody = {
        //       event: "Listed",
        //       price: priceforMarket,
        //       from: from,
        //       to: to
        //     }
        //     await AddActivityNFT(nft._id, activityBody).then((data) => {
        //       toast.dismiss(toastId);
        //       toast(<CustomSuccessToast
        //         transactionHash={transactionHash}
        //         contractAddress={contractAddress}
        //         tokenId={data.data._id}
        //         message={`NFT added to the marketplace successfully!`}
        //       />);
        //       setAutoClose(true)
        //       loadNFT()
        //     })
        //   });
        // } else {
        //   toast.dismiss(toastId);
        //   setAutoClose(true);
        //   toast.error("Unable to find Transfer event in transaction logs.", 'error');
        // }
      }
    } catch (error) {
      toast.dismiss(toastId);
      setAutoClose(true);
      toast.error(error.reason || "Add NFT to Market failed. Please try again.", 'error');
    }
  };

  const sendNFT = async () => {
    if (!receiverAddress || !ethers.isAddress(receiverAddress)) {
      toast.error("Invalid recipient address.");
      return;
    }
    const toastId = pendingToast("Processing for Remove NFT...");
    // setIsTransacting(true);
    setAutoClose(false)
    try {
      const wallet = await PROVIDER.getSigner();

      toast.update(toastId, {
        render: (
          <div className="d-flex align-items-center">
            <Puff size={20} color="#CC0000" />
            <span className="ml-2">Processing transaction...</span>
          </div>
        )
      });
      const contract = new ethers.Contract(nft.contractAddress, ContractABI, wallet);
      const transaction = await contract.transferFrom(walletAddress, receiverAddress, nft.tokenId);
      toast.update(toastId, {
        render: (
          <div className="d-flex align-items-center">
            <Puff size={20} color="#CC0000" />
            <span className="ml-2">Waiting for confirmation...</span>
          </div>
        )
      });
      const receipt = await transaction.wait();
      const receiverUserId = await getUserByAddress(receiverAddress).then((data) => {
        console.log("address", data);
        return data.user._id
      })
      if (receipt) {
        const transferEventSignatures = ethers.keccak256(ethers.toUtf8Bytes("Transfer(address,address,uint256)"));
        // Filter logs for Transfer events
        const logs = receipt.logs.filter((log) => log.topics[0] === transferEventSignatures);
        console.log("Step 5 => logs", logs);

        let tokenId, from, to, transactionHash;
        if (logs.length > 0) {
          logs.forEach(async (log) => {
            // Extract tokenId directly from topics[3]
            const rawFrom = log.topics[1];
            const rawTo = log.topics[2];
            // Decode the 'from' and 'to' addresses, handling zero address scenarios
            from = rawFrom !== `0x${"0".repeat(64)}` ? ethers.getAddress(rawFrom.slice(-40)) : "Minting (no from)";
            to = rawTo !== `0x${"0".repeat(64)}` ? ethers.getAddress(rawTo.slice(-40)) : "Burning (no to)";

            transactionHash = log.transactionHash;
            tokenId = getBigInt(log.topics[3]).toString();
            console.log("Step 6 => Minted Token ID:", tokenId, from, to, transactionHash);

            const NFTbody = {
              listed: false,
              currentOwner: {
                userId: receiverUserId,
                walletAddress: receiverAddress
              }
            }

            console.log("Step 7 => NFTbody", NFTbody);

            await updateNFT(nft._id, NFTbody)
            const activityBody = {
              event: "Transferred",
              price: priceforMarket,
              from: from,
              to: to
            }
            await AddActivityNFT(nft._id, activityBody).then((data) => {
              toast.dismiss(toastId);
              toast(<CustomSuccessToast
                transactionHash={transactionHash}
                contractAddress={contractAddress}
                tokenId={data.data._id}
                message={`Send NFT to other User successfully!`}
              />);
              setAutoClose(true)
              loadNFT()
            })
          });
        } else {
          toast.dismiss(toastId);
          setAutoClose(true);
          toast.error("Unable to find Transfer event in raw logs.");
        }
      }
    } catch (error) {
      toast.dismiss(toastId);
      setAutoClose(true);
      toast.error(error.reason || "Error to send NFT. Please try again.", 'error');
    }
  };

    const handleSetApproval = async () => {
      const toastId = pendingToast("Approving collection...");
      setIsTransacting(true);
  
      try {
        const signer = await PROVIDER.getSigner();
        const contract = new ethers.Contract(
          nft.contractAddress,
          collectionABI,
          signer
        );
  
        const tx = await contract.setApprovalForAll(
          auction_contract_address,
          true
        );
        // Update toast while waiting for confirmation
        toast.update(toastId, {
          render: (
            <div className="d-flex align-items-center">
              <Puff size={20} color="#36d7b7" />
              <span className="ml-2">Waiting for confirmation...</span>
            </div>
          ),
        });
        const receipt = await tx.wait();
  
        if (receipt) {
          toast.dismiss(toastId);
          toast.success("Approval successful!");
  
          closeModals();
  
          // if (state.selectedNFTs.size === 1) {
            await createSingleAuction();
          // }
        }
      } catch (error) {
        toast.dismiss(toastId);
        toast.error("Failed to approve: " + (error.message || "Unknown error"));
        console.error("Approval error:", error);
      }
    };
  
    const createSingleAuction = async () => {
      const toastId = pendingToast("Creating auction...");
      setIsTransacting(true);
  
      try {
        //need to call auction details API for endTime
        const epochTime = new Date(endTime).getTime() / 1000;
        const body = {
          collectionAddress: nft.contractAddress,
          tokenId: nft.tokenId,
          endTime: epochTime,
        };
        console.log("step 1 => body", body);
  
        const { data } = await CreateAuction(body);
        console.log("step 2 => data", data);
  
        toast.update(toastId, {
          render: (
            <div className="d-flex align-items-center">
              <Puff size={20} color="#36d7b7" />
              <span className="ml-2">Processing transaction...</span>
            </div>
          ),
        });
  
        const signer = await PROVIDER.getSigner(walletAddress);
        console.log("step 3 => signer", signer);
       
        const tx = await signer.sendTransaction(data);
        console.log("step 4 => tx", tx);
  
        toast.update(toastId, {
          render: (
            <div className="d-flex align-items-center">
              <Puff size={20} color="#36d7b7" />
              <span className="ml-2">Waiting for confirmation...</span>
            </div>
          ),
        });
  
        const receipt = await tx.wait();
        console.log("step 5 => receipt", receipt);
  
        // if (receipt) {
        //   toast.success("Auction created successfully!");
        //   setTimeout(() => navigate("/live-auctions"), 2000);
        // }
        if (receipt) {
          toast.dismiss(toastId);
          const transferEventSignatures = ethers.keccak256(
            ethers.toUtf8Bytes("Transfer(address,address,uint256)")
          );
        console.log("step 6 => transferEventSignatures", transferEventSignatures);

          // Filter logs for Transfer events
          const logs = receipt.logs.filter(
            (log) => log.topics[0] === transferEventSignatures
          );
          console.log("Step 7 => logs", logs);
  
          let tokenId, from, to, transactionHash;
          if (logs.length > 0) {
            logs.forEach(async (log) => {
              // Extract tokenId directly from topics[3]
              const rawFrom = log.topics[1];
              const rawTo = log.topics[2];
              // Decode the 'from' and 'to' addresses, handling zero address scenarios
              from =
                rawFrom !== `0x${"0".repeat(64)}`
                  ? ethers.getAddress(rawFrom.slice(-40))
                  : "Minting (no from)";
              to =
                rawTo !== `0x${"0".repeat(64)}`
                  ? ethers.getAddress(rawTo.slice(-40))
                  : "Burning (no to)";
  
              transactionHash = log.transactionHash;
              // tokenId = getBigInt(log.topics[3]).toString();
              console.log(
                "Step 8 => Minted Token ID:",
                tokenId,
                from,
                to,
                transactionHash
              );
  
              const NFTbody = {
                inAuction: true,
              };
  
              console.log("Step 9 => NFTbody", NFTbody);
              const NFTId = nft._id;
              await updateNFT(NFTId, NFTbody);
              const activityBody = {
                event: "Auctioned",
                price: 0,
                from: from,
                to: to,
              };
              await AddActivityNFT(NFTId, activityBody).then((data) => {
                toast.success("Auction created successfully!");
                setTimeout(() => navigate("/live-auctions"), 2000);
              });
            });
          } else {
            console.error("Unable to find Transfer event in raw logs.");
          }
        }
      } catch (error) {
        toast.dismiss(toastId);
        toast.error(
          "Failed to create auction: " + (error.message || "Unknown error")
        );
        console.error("Auction creation error:", error);
      } finally {
        setIsTransacting(false);
      }
    };

  async function AddtoAuction(nft) {
    console.log("NFTs for Auction", nft);
    // toast.success("Done in next sprint");
    setTimeSelectModal(true)
  }

  const handleBackClick = () => {
    route(-1)
  };

  const handleLike = (e) => {
    console.log("handleLike triggered"); // Debug log
    e.stopPropagation();

    if (!userId) {
      toast.dismiss();
      toast.error("Please login first!");
      return;
    }

    const body = { userId: userId };

    if (!isLike) {
      console.log("Liking NFT"); // Debug log
      toast.dismiss();
      likeNFT(nftId, body)
        .then((data) => {
          if (data.success) {
            setTimeout(() => {
              toast.success("Liked Successfully!");
              loadNFT()
            }, 2000);
          }
        })
        .catch((error) => {
          console.error("Error liking NFT:", error);
          toast.error("Failed to like. Please try again.");
        });
    } else {
      console.log("Disliking NFT"); // Debug log
      toast.dismiss();
      likeNFT(nftId, body)
        .then((data) => {
          if (data.success) {
            setTimeout(() => {
              toast.success("Disliked Successfully!");
              loadNFT();
            }, 2000);
          }
        })
        .catch((error) => {
          console.error("Error unliking NFT:", error);
          toast.error("Failed to dislike. Please try again.");
        });
    }
  };

  console.log("NFT collectionAddress", nft);

  const closeModal = () => {
    setOpenModalState(false);
    setNftAction(null);
    setPriceForMarket('');
    setReceiverAddress('');
  };

  const openModal = (nft) => {
    console.log("NFT", nft);
    setOpenModalState(true);
  };

  const pendingToast = (message) => {
    return toast(
      <div className="d-flex align-items-center">
        <Puff size={20} color="#CC0000" />
        <span className="ml-2">{message}</span>
      </div>,
      {
        position: "bottom-right",
        autoClose: false,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      }
    );
  };

  const CustomSuccessToast = ({ transactionHash, contractAddress, tokenId, closeToast, message }) => {
    const navigate = useNavigate();

    const handleViewDetails = () => {
      // Navigate to the NFT details page
      navigate(`/nftdetails/${contractAddress}/${tokenId}`);
      // Optionally close the toast after navigation
      closeToast();
    };

    const handleViewOnEtherscan = () => {
      // Open the Etherscan URL in a new tab
      const etherscanUrl = `https://etherscan.io/tx/${transactionHash}`;
      window.open(etherscanUrl, '_blank');
      // Optionally close the toast after opening the link
      closeToast();
    };

    return (
      <div>
        <p>{message}</p>
        <div className="d-flex align-items-center justify-content-between">
          <button className='btn btn-sm btn-grad mr-2' onClick={handleViewDetails}>View Details</button>
          <button className='btn btn-sm btn-grad' onClick={handleViewOnEtherscan}>View on Etherscan</button>
        </div>
      </div>
    );
  };

  function getTimeDifference(timestamp) {
    const now = new Date();
    const past = new Date(timestamp);
    const diffInSeconds = Math.floor((now - past) / 1000);

    const units = [
        { label: "y", seconds: 31536000 },
        { label: "mo", seconds: 2592000 },
        { label: "w", seconds: 604800 },
        { label: "d", seconds: 86400 },
        { label: "h", seconds: 3600 },
        { label: "m", seconds: 60 },
        { label: "s", seconds: 1 }
    ];

    for (const unit of units) {
        const value = Math.floor(diffInSeconds / unit.seconds);
        if (value >= 1) {
            return `${value} ${unit.label}${value > 1 ? 's' : ''} ago`;
        }
    }

    return "Just now";
}

function startRealTimeUpdate(elementId, timestamp) {
    function update() {
        document.getElementById(elementId).innerText = getTimeDifference(timestamp);
    }

    update(); // Initial call
    setInterval(update, 1000); // Update every second
}
  return (
    <div>
      <div className="container">
        <button
          onClick={handleBackClick}
          className="btn btn-white btn-sm my-40 ml-4"
        >
          Back
        </button>
        {nft ?
          <div className="nft_details">
            <div className="row">
              <div className="col-lg-6">
                <div className="nft_img_card">

                  <div className="nft_asset">
                    {nft?.assetType?.split('/')[0] !== "image" ?
                      <video
                        autoPlay muted loop
                        // autoPlay
                        className="AssetMedia--video"
                        // controls="false"
                        controlsList="nodownload"
                        // loop
                        playsInline
                        poster="https://i.seadn.io/s/raw/files/9daca5412390b6adf065ae181d675215.jpg?w=500&auto=format"
                        preload="metadata"
                      >
                        <source
                          data-testid="AssetMedia--video"
                          src={nft.imageUri}
                          // src="https://raw.seadn.io/files/96e4b8dc4e44b869707ea1d91f359fdc.mp4#t=0.001"
                          type="video/mp4"
                        />
                      </video>
                      :
                      <img src={nft.imageUri} alt="NFT" onError={handleError} />
                    }
                  </div>
                </div>

                <div className="panel-container_top mt-3">
                  <div className="panel-header" onClick={() => togglePanel('description')}>
                    <div className="d-flex align-items-center justify-content-start">
                      <MdSubject size={21} />
                      <p> Description</p>
                    </div>
                    <span>{openPanel === 'description' ? <FiChevronUp size={21} /> : <FiChevronDown size={21} />}</span>
                  </div>
                  {openPanel === 'description' && (
                    <div className="panel-body">
                      <p>
                        {nft?.description}
                      </p>
                      <p>
                       Created By <Link to={nft?.creator?.walletAdress === walletAddress ? "/profile" : `/otherProfile/${nft?.creator?.walletAddress}`}>{nft?.creator?.userId?.name}</Link>
                      </p>
                    </div>
                  )}
                </div>
                {nft.attributes && nft?.attributes?.length !== 0 ?
                  <div className="panel-container_null">
                    <div className="panel-header" onClick={() => togglePanel('traits')}>
                      <p> <MdOutlineLabel size={21} /> Traits </p>
                      <span>
                        {openPanel === 'traits' ? <FiChevronUp size={21} /> : <FiChevronDown size={21} />}
                      </span>
                    </div>
                    {openPanel === 'traits' && (
                      <div className="panel-body">
                        {nft?.attributes?.map((item, index) => (
                          <div key={index}>
                            <div className="trait">
                              <span className="" style={{ textTransform: "capitalize" }}>{item.trait_type}</span>
                              <span>{item.value}</span>
                            </div>
                          </div>
                        ))}

                      </div>
                    )}
                  </div>
                  : ""
                }
                <div className="panel-container_bottom">
                  <div className="panel-header" onClick={() => togglePanel('about')}>
                    <p><MdOutlineVerticalSplit size={21} /> About {collectionDetails !== null ? collectionDetails.name : "DtoC"}  </p>
                    <span>
                      {openPanel === 'about' ? <FiChevronUp size={21} /> : <FiChevronDown size={21} />}
                    </span>
                  </div>
                  {openPanel === 'about' && (
                    <div className="panel-body">
                      <p>
                        {nft?.description}
                      </p>
                    </div>
                  )}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="nft_details_1 d-flex align-items-center justify-content-between">
                  <h4>
                    {collectionDetails !== null ? collectionDetails.name : "DtoC"}
                  </h4>
                  {/* <Link to='#'>
                    <span>
                      {nft.collectionName}
                    </span>
                  </Link> */}
                </div>
                <div className="d-flex align-items-center justify-content-between">

                  <div>
                    <h2>
                      {nft?.title}
                    </h2>
                    <p>

                      own by <Link to={`/otherProfile/${nft?.currentOwner?.walletAddress}`} target="_blank">{nft?.currentOwner?.userId?.name}</Link>
                    </p>
                  </div>
                  <a
                    data-tooltip-id="nft-clipboard"
                    data-tooltip-content="Copy Link!"
                    data-tooltip-place="bottom"
                  >
                    <div
                      className="icons  d-flex align-items-center justify-content-between">
                      <CopyToClipboard
                        text={codeSnippet}
                        onCopy={onCopyText}
                        style={{ cursor: 'pointer' }}
                      >
                        <span className="p3 ms-2">
                          {isCopied ? "Copied!" : <MdIosShare size={23} />}
                        </span>
                      </CopyToClipboard>
                    </div>
                    <Tooltip id="nft-clipboard" />
                  </a>

                </div>
                <div className="nft_details_2 my-2">
                  <div className="nft_rank">
                    <div className="mx-1">
                      <MdOutlineRemoveRedEye />
                    </div>
                    <div>
                      {nft?.totalViews}
                      <span className="mx-2">
                        views
                      </span>
                    </div>
                  </div>
                  <div className="nft_rank mx-2" onClick={handleLike}>
                    {isLike ?
                      <>
                        <FaHeart color="red" className="mx-2" />
                      </>
                      :
                      <FaRegHeart className="mx-2" />
                    }
                    {` ${nft.totalLikes ? nft.totalLikes : "0"}`} fav </div>
                </div>
                <div>
                  <h6>
                    View proof of authenticity
                  </h6>
                </div>
                <div className="d-flex">
                  {/* {authenticity.map((p) => ( */}
                  <button
                    className="btn btn-white btn-sm p4 mt-2 mr-2"
                    type="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <a
                      href={nft.tokenUri}
                      target="_blank"
                      rel="noreferrer"
                      style={{ pointerEvents: true ? 'auto' : 'none' }}
                    >
                      <span className="p4 mx-2">
                        <img src={ipfsImg} width="20" alt="" />

                      </span>
                      <span>
                        {"View on IPFS"}

                      </span>
                    </a>
                  </button>
                  <button
                    className="btn btn-white btn-sm p4 mt-2 mr-2"
                    type="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <a
                      href={`https://sepolia.etherscan.io/tx/${nft.transactionHash}`}
                      target="_blank"
                      rel="noreferrer"
                      style={{ pointerEvents: true ? 'auto' : 'none' }}
                    >
                      <span className="p4 mx-2">
                        <img src={ether} width="20" alt="" />
                      </span>
                      <span>
                        {"View on Block Explorer"}

                      </span>
                    </a>
                  </button>

                  {/* // ))} */}
                </div>
                <div className="panel-container mt-3">
                  <div className="panel-body">
                    {/* {collectionAddress === contractAddress && nft?.currentOwner?.walletAddress === walletAddress && nft.listed && */}
                    <div>
                      <p>Current price</p>
                      <div className="d-flex">
                        <h3>
                          {nft?.price ?? "N/A"} ETH
                        </h3>
                        <span className="mx-2">${priceInDoller}</span>
                      </div>
                    </div>
                    {/* } */}
                    <>
                      {(collectionAddress === contractAddress && nft?.currentOwner?.walletAddress !== walletAddress && nft.listed && nft.type !== "Lazy Mint" &&
                        <div className="d-flex align-items-center justify-content-between">
                          <button className="btn btn-md btn-primary w-50 m-2" onClick={() => buyNft()}>Buy Now</button>
                        </div>)}
                      {(collectionAddress === contractAddress && nft?.currentOwner?.walletAddress === walletAddress && nft.listed && nft.type !== "Lazy Mint" &&
                        <div className="d-flex align-items-center justify-content-between">
                          <button className="btn btn-md btn-primary w-50 m-2" onClick={() => RemoveFromMarket()}>Remove from Market</button>
                        </div>)

                      }
                      {(collectionAddress === contractAddress && nft?.currentOwner?.walletAddress === walletAddress && nft.listed === false && nft.type !== "Lazy Mint" &&
                        <div className="d-flex align-items-center justify-content-between">
                          {/* <button className="btn btn-md btn-primary w-50 m-2" onClick={() => buyNft()}>Add to Market</button> */}
                          <button className="btn btn-md btn-primary w-50 m-2" onClick={() => openModal()}>Trade </button>
                        </div>
                      )}
                      {(nft?.currentOwner?.walletAddress !== walletAddress && nft.listed === false && nft.type === "Lazy Mint" &&
                        <div className="d-flex align-items-center justify-content-between">
                          {/* <button className="btn btn-md btn-primary w-50 m-2" onClick={() => buyNft()}>Add to Market</button> */}
                          <button className="btn btn-md btn-primary w-50 m-2" onClick={() => buyLazyNft()}>Buy Now </button>
                        </div>
                      )}
                    </>
                  </div>
                </div>
                {collectionAddress !== contractAddress && (nft?.currentOwner?.walletAddress === walletAddress && nft.listed &&
                  <div className="panel-container mt-3">
                    <div className="panel-body">

                      <div className="d-flex align-items-center justify-content-between">
                        <button className="btn btn-md btn-primary w-50 m-2" onClick={() => AddtoAuction(nft)}>Add for Auction</button>
                      </div>
                    </div>
                    {/* )} */}
                  </div>
                )
                }
                <div className="panel-container mt-3">
                  <div className="panel-header py-1" onClick={() => setOpenPanel1("details")}>
                    <div className="d-flex align-items-center justify-content-strat">

                      <MdOutlineBallot size={25} className="my-2" />
                      <p >
                        Details </p>
                    </div>
                    <span>
                      {openPanel1 === "details" ? <FiChevronUp size={21} /> : <FiChevronDown size={21} />}
                    </span>
                  </div>
                  {openPanel1 === "details" && (
                    <div className="panel-body">
                      <div className="trait">
                        <div>
                          Contract Address
                        </div>
                        <div>{contractAddress.slice(0, 10)}....{contractAddress.slice(-10)}</div>
                      </div>
                      <div className="trait">
                        <div>
                          Token Id
                        </div>
                        <div>{nft.tokenId ? nft.tokenId : `N/A`}</div>
                      </div>
                      <div className="trait">
                        <div>
                          Collection Name
                        </div>
                        <div>  {collectionDetails ? collectionDetails.name : "DtoC"}</div>
                      </div>
                      <div className="trait">
                        <div>
                          Token Standard
                        </div>
                        <div>ERC-721</div>
                      </div>

                    </div>
                  )}
                </div>
                {/* {nft?.activity.length !== 0 &&
                  <div className="panel-container mt-3">
                    <div className="panel-header" onClick={() => togglePanel('history')}>
                      <p> <SlGraph size="24" /> History</p>
                      <span>{openPanel === 'history' ? <FiChevronUp size={21} /> : <FiChevronDown size={21} />}</span>
                    </div>
                    {openPanel === 'history' && (
                      <div className="panel-body">
                        <div className="table-responsive mt-4">
                          <table className="table table-hover">
                            <thead>
                              <tr>
                                <th>Event</th>
                                <th>Price (ETH)</th>
                                <th>From</th>
                                <th>To</th>
                                <th>Date</th>
                              </tr>
                            </thead>
type                            <tbody>
                              {nft.activity.map(async (activity, index) => {
                                // Get user details for 'from' address
                                let fromUser = null;
                                let toUser = null;
                                try {
                                  const fromUserData = await getUserByAddress(activity.from);
                                  if (fromUserData?.user) {
                                    fromUser = fromUserData.user;
                                  }
                                  const toUserData = await getUserByAddress(activity.to);
                                  if (toUserData?.user) {
                                    toUser = toUserData.user;
                                  }
                                } catch (error) {
                                  console.error('Error fetching user data:', error);
                                }

                                return (
                                  <tr key={index}>
                                    <td>
                                      <span className={`nft-activity-event event-${activity.event.toLowerCase()}`}>
                                        {activity.event}
                                      </span>
                                    </td>
                                    <td>{activity.price} ETH</td>
                                    <td>
                                      <Link to={`/otherProfile/${activity.from}`} className="text-truncate d-inline-block" style={{maxWidth: '150px'}}>
                                        {fromUser?.name || `${activity.from.slice(0, 6)}...${activity.from.slice(-4)}`}
                                      </Link>
                                    </td>
                                    <td>
                                      <Link to={`/otherProfile/${activity.to}`} className="text-truncate d-inline-block" style={{maxWidth: '150px'}}>
                                        {toUser?.name || `${activity.to.slice(0, 6)}...${activity.to.slice(-4)}`}
                                      </Link>
                                    </td>
                                    <td>{new Date(activity.createdAt).toLocaleString()}</td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </div>
                } */}

              </div>
            </div>
            {properties?.length !== 0 &&
              <div className="panel-container mt-3">
                <div className="panel-header" onClick={() => togglePanel('activity')}>
                  <p> <MdOutlineSwapVert size={21} />  Item Activity</p>
                  <span>{openPanel === 'activity' ? <FiChevronUp size={21} /> : <FiChevronDown size={21} />}</span>
                </div>
                {openPanel === 'activity' && (
                  <div className="panel-body">

                    {properties.map((item, index) => (
                      <div key={index} style={{ marginBottom: "20px" }}>
                        {Object.entries(item).map(([key, value], idx) => (
                          <p key={idx}>
                            <strong>{key}</strong>: {value}
                          </p>
                        ))}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            }
            {nft?.activity.reverse().length !== 0 &&
              <div className="panel-container mt-3">
                <div className="panel-header" onClick={() => togglePanel('history')}>
                  <p> <SlGraph size="24" /> Activity</p>
                  <span>{openPanel === 'history' ? <FiChevronUp size={21} /> : <FiChevronDown size={21} />}</span>
                </div>
                {openPanel === 'history' && (
                  <div className="panel-body">
                    <div className="table-responsive mt-4">
                      <table className="table table-hover activity-table">
                        <thead>
                          <tr>
                            <th>Event</th>
                            <th>Price (ETH)</th>
                            <th>From</th>
                            <th>To</th>
                            <th>Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {nft.activity.map((activity, index) => (
                            <tr key={index}>
                              <td>
                                <span className={`badge ${activity.event === 'Minted' ? "event-minted" : activity.event === 'Transferred' ? "event-transferred" : activity.event === 'Auctioned' ? "event-auctioned" : activity.event === 'Fractionalized' ? "event-fractionalized" : activity.event === 'Listed' ? 'event-listed' : activity.event === 'Traded' ? 'event-traded' : 'bg-info'}`}>
                                  {activity.event}
                                </span>
                              </td>
                              <td>{activity.price} ETH</td>
                              <td>
                                <Link to={activity.from === walletAddress ? "/profile" : `/otherProfile/${activity.from}`} className="text-truncate d-inline-block" style={{ maxWidth: '150px' }}>
                                  {activity.fromUser === null ? `${activity.from.slice(0, 6)}...${activity.from.slice(-4)}` : activity.fromUser.name}
                                </Link>
                              </td>
                              <td>
                                <Link to={activity.to === walletAddress ? "/profile" : `/otherProfile/${activity.to}`} className="text-truncate d-inline-block" style={{ maxWidth: '150px' }}>
                                  {activity.toUser === null ? `${activity.to.slice(0, 6)}...${activity.to.slice(-4)}` : activity.toUser.name}
                                </Link>
                              </td>
                              <td>
                                {getTimeDifference(activity.timestamp)} <FaArrowUpLong size={12} style={{ display: "inline-block", transform: "rotate(45deg)" }}   /> 
                              </td>
                            </tr>
                            // );
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </div>
            }
            <div className="panel-container mt-3">
              <div className="panel-header" onClick={() => togglePanel('collection')}>
                <p> <MdCalendarViewMonth size={21} /> More From This Collection </p>
                <span>
                  {openPanel === 'collection' ? <FiChevronUp size={21} /> : <FiChevronDown size={21} />}
                </span>
              </div>
              {openPanel === 'collection' && (
                <div className="panel-body">
                  <div className='py-4'>
                    <CollcetionItemCard contractAddress={collectionAddress} />
                  </div>
                </div>
              )}
            </div>
          </div> :
          <h3>
            Loading...
          </h3>
        }
      </div>
      <ToastContainer
        position="bottom-right"
        newestOnTop={true}
        autoClose={false}
        closeOnClick={false}
        closeButton={autoClose}
        rtl={false}
        pauseOnFocusLoss={false}
        draggable={false}
      />

      <Modal show={openModalState} size="lg" onHide={closeModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Select an action for the {nft?.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h3>Select an option to send or add to the market</h3>
          {!nftAction && (
            <div className="my-2">
              <Button onClick={() => setNftAction('send')}>Send</Button>
              <Button onClick={() => setNftAction('market')} className="mx-3">
                Add to Market
              </Button>
            </div>
          )}
          {nftAction === 'send' && (
            <div className='my-4'>
              <h4>Enter recipient's wallet address</h4>
              <input
                type="text"
                className="form-control"
                placeholder="Wallet Address"
                value={receiverAddress}
                onChange={(e) => setReceiverAddress(e.target.value)}
              />
            </div>
          )}
          {nftAction === 'market' && (
            <div className='my-4'>
              <h4>Set Price for Redeployment</h4>
              <input
                type="number"
                className="form-control"
                placeholder="Price"
                value={priceforMarket}
                onChange={(e) => setPriceForMarket(e.target.value)}
                min="0" // Prevents entering negative numbers
                step="0.01" // Optional: Allows decimal numbers
              />
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={closeModal}>Cancel</Button>
          <Button
            onClick={() => {
              if (nftAction === 'market') {
                redeployOnMarketplace();
              } else if (nftAction === 'send') {
                sendNFT();
              }
            }}
          >
            {nftAction === 'market' ? 'Add to Market' : 'Send'}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={timeSelectModal} size="lg" onHide={()=> setTimeSelectModal(!timeSelectModal)} centered>
            <Modal.Header closeButton>
              <Modal.Title>Auction</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <h4>Please add End Time</h4>
              <p>
                <input
                  type="datetime-local"
                  value={endTime}
                  onChange={(e) => setEndTime(e.target.value)}
                  min={new Date().toISOString().slice(0, -8)}
                />
              </p>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={()=> setTimeSelectModal(!timeSelectModal)}>Cancel</Button>
              <Button onClick={handleSetApproval}>Auction</Button>
            </Modal.Footer>
          </Modal>
    </div>
  );
};
